import { axios, AxiosResponse } from '@/config/plugins/axios';
import { FormValue } from '@/functions/getFormValue';
import { Filter, Pagination, Patient } from '@/types';

const patient = {
	fetchPatients(
		projectToken: string,
		type: string,
		field: string,
		pagination: Pagination,
		filters?: string[],
		search?: string,
		advancedSearch?: any
	): Promise<AxiosResponse<any>> {
		const params = {
			filters: [] as Filter[],
			itemsPerPage: pagination.itemsPerPage,
			sortDesc: pagination.sortDesc,
			page: pagination.page,
			sortBy: pagination.sortBy,
			search,
			advancedSearch
		};

		if (0 === pagination.sortBy?.length) {
			params.sortBy = null;
			params.sortDesc = null;
		}

		if (filters && 0 < filters.length) {
			params.filters.push({
				field,
				operator: 'in',
				values: filters
			});
		}

		return axios.get(`/api/projects/${projectToken}/patients/type/${type}`, { params });
	},

	createPatient(projectToken: string, type: string, data: FormValue): Promise<AxiosResponse<any>> {
		return axios.post(`/api/projects/${projectToken}/patients/type/${type}`, data);
	},

	getListPatient(projectToken: string, type: string, nirOpeningRight: string): Promise<AxiosResponse<any>> {
		return axios.post(`/api/projects/${projectToken}/beneficiaires/type/${type}`, { nirOpeningRight });
	},

	getAvailablePatientList(projectToken: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/linkable-patient`);
	},

	deletePatient(projectToken: string, patientToken: string, dataLineToken: string): Promise<AxiosResponse<any>> {
		return axios.delete(`/api/projects/${projectToken}/patients/${patientToken}/data/${dataLineToken}`);
	},

	getCreatePatientForm(projectToken: string, type: string, data: any = {}): Promise<AxiosResponse<any>> {
		return axios.post(`/api/projects/${projectToken}/patients/type/${type}/form`, {
			...data
		});
	},

	getEditPatientForm(projectToken: string, patientToken: string, type: string, dataLineToken: string, data: FormValue): Promise<AxiosResponse<any>> {
		return axios.put(`/api/projects/${projectToken}/patients/${patientToken}/type/${type}/data/${dataLineToken}/form`, data);
	},

	editPatient(projectToken: string, patientToken: string, type: string, dataLineToken: string, data: FormValue): Promise<AxiosResponse<any>> {
		return axios.put(`/api/projects/${projectToken}/patients/${patientToken}/type/${type}/data/${dataLineToken}`, data);
	},

	getPatientName(patient: Patient): string {
		if (patient.usualName && patient.lastName !== patient.usualName) {
			return `${patient.firstName} ${patient.usualName} - né(e) ${patient.lastName}`;
		}

		return `${patient.firstName} ${patient.lastName}`;
	},

	getAllByNir(nir: string): Promise<AxiosResponse<any>> {
		const params = { nir };

		return axios.get('/api/patients', { params });
	},

	getPatientListContext(projectToken: string, type: string): Promise<AxiosResponse<any>> {
		return axios.get(`/api/projects/${projectToken}/patients/type/${type}/context`);
	},

	getPatientsAdvancedSearch(projectToken: string, type: string) {
		return axios.get(`/api/projects/${projectToken}/patients/type/${type}/advanced-search`);
	}
};

export default patient;
